

export const addTherapyType = (therapyType) => {
    return {
        type: 'ADD_THERAPY_TYPE',
        payload: therapyType
    }
}

export const addProblems = (problemArray) => {
    return {
        type: 'ADD_PROBLEM',
        payload: problemArray
    }
}

export const selectGender = (genderType) => {
    return {
        type: 'SELECT_GENDER',
        payload: genderType
    }
}

export const setAge = (age) => {
    return {
        type: 'SET_AGE',
        payload: age
    }
}